<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/LihVP3/tc-custom/9781504065016.jpg?1705177550923" alt="This image is the cover for the book Oz Series Volume Four, The Oz Series"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Oz Series Volume Four, The Oz Series
      </h1>
      <p class="bookDescription body article font2">
        <b>These four books in the classic children’s fantasy series follow the continuing adventures of Dorothy, the Wizard of Oz, and other beloved characters.</b><br/><br/><i>The Lost Princess of Oz</i>: When Princess Ozma disappears, Dorothy Gale and the Wizard of Oz set out to find her. Together with Dorothy’s friend Trot and the young boy Button-Bright, they find themselves in the dangerous land of the powerful Wizard Ugu.<br/><br/><i>The Tin Woodman of Oz</i>: This magical tale recounts how the Tin Woodman was turned into a tin man by the Wicked Witch of the East. It then follows him on a new adventure as he goes in search of his lost love, aided by his good friend the Scarecrow.<br/>  <br/><i>The Magic of Oz</i>: When a boy named Kiki Aru discovers a magical word that only he can pronounce, his mischief wins him a villainous friend, Ruggedo the Nome. Now Dorothy, the Wizard, and the Cowardly Lion must stop Ruggedo from using Kiki’s magic to take over Oz.<br/>  <br/><i>Glinda of Oz</i>: In the final book of the original Oz series, Dorothy and Princess Ozma set out to stop a war between two obscure tribes. But when they’re taken captive, it’s up to Glinda the Good to save the day—with a little help from the Wizard, the Scarecrow, the Cowardly Lion, and the Tin Woodman.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        L. Frank Baum
      </h2>
      
      <p class="authorDescription body article">L. Frank Baum (1856&ndash;1919) was born in upstate New York and began writing stories at a very young age. Best known as the author of the beloved children&rsquo;s classic <I>The Wonderful Wizard of Oz</I>, he wrote thirteen sequels set in the Land of Oz and numerous other novels, poems, and plays.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?494f7eec